import { render, staticRenderFns } from "./IconTimes.vue?vue&type=template&id=2383cbc6"
import script from "./IconTimes.vue?vue&type=script&lang=js"
export * from "./IconTimes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports